import axios from "./HTTP";

export default {
  create(params, callback, errorCallback) {
    axios
      .post(`/api/out_of_office.json`, params)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  get(callback, errorCallback) {
    axios
      .get(`/api/out_of_office.json`)
      .then(response => callback(response.data))
      .catch(error => {
        errorCallback(error);
      });
  }
};
